export default __webpack_public_path__ + "static/media/man-getting-loan.3fb2ba6a.svg";